// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__ln1bc {
    display: flex;
    justify-content: center;
    align-items: center;
    /* max-width: 90vw !important; */
    max-height: 90vh !important;
    height: auto;
    /* min-width: 70vw; */
    /* min-width: 50vw !important; */
    width:844px !important;
    /* padding:10px; */
    /* min-height:60px; */
}

.styles_container__ln1bc img {
    /* max-width:90% !important;
    max-height:90% !important; */
    max-height: 50vh;
    width: auto;
    /* min-height: 20vh; */
    max-width: 90%;
}

.styles_container__ln1bc>div>div {
    min-height: 10vh;
}

.styles_container__ln1bc video {
    max-width: 90% !important;
    max-height: 80vh !important;

}

.styles_zoomImageContainer__YwnjD {
    /* min-width:50%; */
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

.styles_svgBackground__9Nzxu {
    background-color: #ccc;
}

@media only screen and (max-width: 944px) {

    .styles_container__ln1bc{
        min-width: 70vw;
        max-width:90vw;
    }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/ZoomModalContent/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;IAChC,2BAA2B;IAC3B,YAAY;IACZ,qBAAqB;IACrB,gCAAgC;IAChC,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI;gCAC4B;IAC5B,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;;AAE/B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI;QACI,eAAe;QACf,cAAc;IAClB;AACJ","sourcesContent":[".container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* max-width: 90vw !important; */\n    max-height: 90vh !important;\n    height: auto;\n    /* min-width: 70vw; */\n    /* min-width: 50vw !important; */\n    width:844px !important;\n    /* padding:10px; */\n    /* min-height:60px; */\n}\n\n.container img {\n    /* max-width:90% !important;\n    max-height:90% !important; */\n    max-height: 50vh;\n    width: auto;\n    /* min-height: 20vh; */\n    max-width: 90%;\n}\n\n.container>div>div {\n    min-height: 10vh;\n}\n\n.container video {\n    max-width: 90% !important;\n    max-height: 80vh !important;\n\n}\n\n.zoomImageContainer {\n    /* min-width:50%; */\n    width: auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.svgBackground {\n    background-color: #ccc;\n}\n\n@media only screen and (max-width: 944px) {\n\n    .container{\n        min-width: 70vw;\n        max-width:90vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__ln1bc`,
	"zoomImageContainer": `styles_zoomImageContainer__YwnjD`,
	"svgBackground": `styles_svgBackground__9Nzxu`
};
export default ___CSS_LOADER_EXPORT___;
